function initCarousel(){
	if ($('.js-carousel').length) {
		$('.js-carousel').slick({
			infinite: true,
			speed: 1000,
			cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
			dots: true,
			arrows: true,
			prevArrow: '<a class="slick-prev"><i class="icon icon-arrow-left"></i></a>',
			nextArrow: '<a class="slick-next"><i class="icon icon-arrow-right"></i></a>',
		});
		$('.js-carousel').on('breakpoint', function () {
			$(this).find('.js-async-bg').addClass('not-loaded');
			asyncBg();
		});
	}
	if ($('.js-carousel-lightbox').length) {
		$('.js-carousel-lightbox').slick({
			infinite: true,
			speed: 1000,
			cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
			dots: true,
			arrows: true,
			centerMode: false,
      centerPadding: '150px',
      adaptiveHeight: true,
			slidesToShow: 1,
			prevArrow: '<a class="slick-prev"><i class="icon icon-arrow-left"></i></a>',
			nextArrow: '<a class="slick-next"><i class="icon icon-arrow-right"></i></a>',
			// responsive: [
			// 	{
			// 		breakpoint: 1100,
			// 		settings: {
			// 			centerMode: false,
			// 		}
			// 	}]
		});
		$('.js-carousel-lightbox').on('breakpoint', function () {
			$(this).find('.js-async-bg').addClass('not-loaded');
			asyncBg();
		});
	}
};

$(function(){
	$('.js-media').on('click', function(){
		$('.js-carousel-lightbox').slick('slickGoTo', $(this).data('index'), true);
	})
});
